import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { LabeledInput as UnstyledLabeledInput } from 'components/LabeledInput'
import useFeatureToggle from 'hooks/useFeatureToggle'
import useSurveyChoiceOrder from 'hooks/useSurveyChoiceOrder'

const RATING_SENTIMENT = {
  1: 'negative',
  2: 'negative',
  3: 'neutral',
  4: 'positive',
  5: 'positive',
}

const SCALE_RATING = {
  2: [2, 4],
  3: [2, 3, 4],
  4: [2, 3, 4, 5],
  5: [1, 2, 3, 4, 5],
}

const LabeledInput = styled(UnstyledLabeledInput)`
  &:not(:first-child) {
    margin-top: 0.5em;
  }
`

const Image = styled.img`
  &.use.this.style {
    height: 32px !important;
  }
`

const getLabelText = (label) => {
  if (typeof label === 'string') {
    return label
  }
  return ''
}

export const CsatChoiceInput = ({ choices, scale, createOnChange, iconSet }) => {
  const DEFAULT_ICON_SET_IMAGE_URL =
    'https://cdn.simplesat.io/images/missing-icon-set-thumbnail.png'

  const { enableRatingChoiceOrder } = useFeatureToggle()
  const isReverseOrder = useSurveyChoiceOrder()
  const baseRatings = SCALE_RATING[scale] || []
  const ratings =
    enableRatingChoiceOrder && !isReverseOrder ? [...baseRatings].reverse() : baseRatings

  return ratings.map((rating, visualIndex) => {
    const sentiment = RATING_SENTIMENT[rating]
    const icon = iconSet[rating] || DEFAULT_ICON_SET_IMAGE_URL
    const choiceIndex = choices.findIndex((c) => c && c.value == rating)
    const choice = choiceIndex > -1 ? choices[choiceIndex] : {}
    const onChangeIndex = choiceIndex > -1 ? choiceIndex : visualIndex

    return (
      <LabeledInput
        key={rating}
        className="choice-item"
        inputProps={{ maxLength: '250', required: true }}
        labelProps={{ style: { padding: 8 } }}
        label={<Image className="use this style" src={icon} alt={sentiment} />}
        value={getLabelText(choice?.label)}
        onChange={createOnChange(onChangeIndex)}
      />
    )
  })
}

CsatChoiceInput.propTypes = {
  choices: PropTypes.arrayOf(PropTypes.object),
  scale: PropTypes.oneOf([2, 3, 4, 5]),
  createOnChange: PropTypes.func,
  iconSet: PropTypes.object,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/CsatChoiceInput/index.js